module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_styled_03-ea8b05b8dfb86500accde29c4353c043.jpg";